import React from "react";
import PropTypes from "prop-types";
import Icon from "../../Common/Icon";

const createFormDataModel = (data, dataModel = {}, prefix) => {
  Object.keys(data).forEach((key) => {
    const value = data[key];
    key = prefix ? `${prefix}.${key}` : key;
    if (value instanceof Object && !(value instanceof Array)) {
      dataModel = createFormDataModel(value, dataModel, key);
      return;
    }
    dataModel[key] = value;
  });
  return dataModel;
};

const submitFormData = (action, data) => {
  var form = document.createElement("form");
  form.style.display = "none";
  form.method = "POST";
  form.action = action;
  const dataModel = createFormDataModel(data);
  Object.keys(dataModel).forEach((key) => {
    var input = document.createElement("input");
    input.name = key;
    input.value = dataModel[key];
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
};

const Button = (props) => {
  let {
    config: {
      label = "Button",
      class: className = "",
      alignRight = false,
      alignRightOnMobile = false,
      href,
      target = "_self",
      action,
      leftIcon,
      rightIcon,
      formData,
    },
    formik,
    form,
  } = props;

  className = `btn btn--in-form 
  ${alignRight ? "btn--align-right" : ""} 
  ${alignRightOnMobile ? "btn--align-right-on-mobile" : ""} 
    ${className}`;

  const Wrapper = (props) =>
    href && !formData ? (
      <a className={className} href={href} target={target}>
        {props.children}
      </a>
    ) : (
      <button
        className={className}
        type="button"
        onMouseUp={(e) => {
          if (action === "resetForm") {
            formik.resetForm({});
            return;
          }

          if (action === "resetGender") {
            formik.setFieldValue("Aanhef", "");
            form.fieldChanged("Aanhef", "");
            return;
          }

          if (href && formData) {
            submitFormData(href, formData);
            return;
          }
          window.history.go(-1);
        }}
      >
        {props.children}
      </button>
    );
  return (
    <Wrapper>
      {leftIcon ? (
        <Icon className="btn__icon btn__icon--left" iconName={leftIcon} />
      ) : null}
      {label}
      {rightIcon ? (
        <Icon className="btn__icon btn__icon--right" iconName={rightIcon} />
      ) : null}
    </Wrapper>
  );
};

Button.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Button.js